// src/App.js

import React, { useState } from 'react';
import ProductList from './components/ProductList';
import ProductDetail from './components/ProductDetail';
import './App.css';

/**
 * Componente principal de la aplicación Ansaldo Product Price Analytics.
 * Optimizado para ocupar todo el viewport y mejorar la experiencia de usuario
 * para la toma de decisiones respecto a precios.
 */
function App() {
    const [selectedProduct, setSelectedProduct] = useState(null);

    return (
        <div className="App" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <header className="App-header" style={{ flex: '0 0 auto' }}>
                <h3 style={{
                    padding: '0',
                    margin: '0'
                }}>
                    <span role="img" aria-label="analytics">📊</span> Ansaldo Product Price Analytics
                </h3>
                <p style={{ fontSize: 18, color: '#b0bec5', margin: 0 }}>
                    Analiza, compara y toma mejores decisiones de precios en tiempo real.
                </p>
            </header>
            <main
                style={{
                    flex: '1 1 0',
                    display: 'flex',
                    flexDirection: 'row',
                    minHeight: 0,
                    background: 'linear-gradient(90deg,#e3f2fd 0%,#f7f7f7 100%)',
                }}
            >
                <aside
                    style={{
                        flex: '0 0 370px',
                        minWidth: 320,
                        maxWidth: 400,
                        borderRight: '1px solid #e0e0e0',
                        background: 'rgba(255,255,255,0.97)',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: 0,
                        boxShadow: '2px 0 8px #e3f2fd33',
                        zIndex: 2,
                    }}
                >
                    <ProductList
                        onSelect={setSelectedProduct}
                        selectedProduct={selectedProduct}
                        style={{ flex: 1, minHeight: 0, height: '100%' }}
                    />
                </aside>
                <section
                    style={{
                        flex: 1,
                        padding: '32px 2vw',
                        overflowY: 'auto',
                        minHeight: 0,
                        background: 'transparent',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    {selectedProduct ? (
                        <ProductDetail productId={selectedProduct.id} />
                    ) : (
                        <div
                            style={{
                                color: '#789',
                                marginTop: '18vh',
                                textAlign: 'center',
                                fontSize: 22,
                                opacity: 0.9,
                            }}
                        >
                            <h2>
                                <span role="img" aria-label="search">🔎</span> Selecciona un producto para analizar precios y tendencias
                            </h2>
                            <p>
                                Visualiza métricas clave, compara tiendas y toma decisiones informadas.
                            </p>
                        </div>
                    )}
                </section>
            </main>
            <footer
                style={{
                    textAlign: 'center',
                    padding: 16,
                    background: '#222d3a',
                    color: '#fff',
                    fontSize: 15,
                    letterSpacing: 1,
                    boxShadow: '0 -2px 8px #e3f2fd33',
                    flex: '0 0 auto',
                }}
            >
                &copy; {new Date().getFullYear()} Ansaldo Price Analytics &mdash; Decisiones inteligentes para tu negocio
            </footer>
        </div>
    );
}

export default App;
